<template>
    <FormulateForm v-model="formData" :errors="$page.props.errors" novalidate @submit="handleSubmit">
        <div class="form_field">
            <IconEmail class="form_field_prefix" />
            <FormulateInput
                type="email"
                name="email"
                validation="required|email"
                placeholder="Email"
            />
        </div>
        <div class="form_field">
            <IconLock class="form_field_prefix" />
            <FormulateInput
                :type="!passwordVisibility.value ? 'password' : 'text'"
                name="password"
                placeholder="Password"
                validation="required"
            />
            <button type="button" class="form_field_sufix" @click="passwordVisibility.toggle">
                <IconEyeOpen v-if="passwordVisibility.value" />
                <IconEyeHide v-if="!passwordVisibility.value" />
            </button>
        </div>

        <div class="form_row">
            <FormulateInput
                type="checkbox"
                name="remember"
                label="Remember me"
                error-behavior="submit"
            />
            <Link class="loginWrap_buttonBack" :href="route('password.request')">
                Forgot password?
            </Link>
        </div>
        <FormulateInput type="submit" label="Login" class="submitButton" />
    </FormulateForm>
</template>

<script setup lang="ts">
import { Link, router } from '@inertiajs/vue2';
import IconEmail from '@/components/icons/IconEmail.vue';
import IconEyeHide from '@/components/icons/IconEyeHide.vue';
import IconEyeOpen from '@/components/icons/IconEyeOpen.vue';
import IconLock from '@/components/icons/IconLock.vue';
import { usePasswordVisibility } from '../composables/passwords';
import type { LoginFormData, Incomplete } from '../types';
import { reactive } from 'vue';
import route from 'ziggy-js';

const passwordVisibility = usePasswordVisibility();

const formData = reactive<Incomplete<LoginFormData>>({
    password: null,
    email: null,
    remember: null,
});

function handleSubmit(data: LoginFormData) {
    router.post(route('login'), data);
}
</script>
